import TimingTime from '../timing/timing-time.vue';

export default TimingTime;



// WEBPACK FOOTER //
// ./src/components/timing-time/index.js